import axios from "axios";
import { signout } from "../../components/utils/extra/signout";

export const verifyApi = async (setAuth, lang, token, removeCookies) => {
  let config = {
    method: "get",
    url: `${process.env.REACT_APP_API}/verify`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 15000,
  };

  try {
    const res = await axios(config);

    setAuth((prev) => ({
      ...prev,
      isAuthenticated: true,
      role: res.data.data.roles,
    }));
  } catch (error) {
    if (error.response) {
      signout(setAuth, removeCookies);
    }
  }
};
